<template>
  <div
    :class="{ 'col-md-6': !isMaintainer, 'col-12': isMaintainer }"
    v-if="bookData"
  >
    <div class="row">
      <div class="col-12 mb-4">
        <div
          class="elevation-2 radius-5 box mx-auto px-3 pb-3"
          :class="{ pointer: isMaintainer ? false : true }"
        >
          <div
            v-if="!isMaintainer"
            class="radius elevation-3 like-container"
            @click="setFavorite"
          >
            <i
              class="fas fa-heart like"
              :class="{
                'text-blue': bookData.userFavorite,
                'text-gray': !bookData.userFavorite,
              }"
            >
            </i>
          </div>
          <div
            class="row text-initial"
            @click="isMaintainer ? '' : $emit('openBookModal')"
          >
            <div class="col-12 text-center">
              <div
                class="col-12 font-weight-bold mt-2 card-title"
                style="min-height: 0;"
              >
                {{ bookData.title }}
              </div>
              <!-- <div
                class="col-12 d-flex justify-content-around"
                v-if="assignationData"
              >
                <span>
                  <strong>
                    Fecha inicial
                  </strong>
                  <br />
                  {{ assignationData.startingDate }}
                </span>
                <span>
                  <strong>
                    Fecha final
                  </strong>
                  <br />
                  {{ assignationData.evaluationDate }}
                </span>
              </div> -->
              <div class="col-12 text-center">
                <img
                  :src="
                    `https://assets.beereaders.com/lbr/image/${bookData.resourceDir}/cover_medium.jpg`
                  "
                />
              </div>
              <div class="col-12 subtitle">
                {{ bookData.authorDTO ? bookData.authorDTO.name : "" }}
              </div>
            </div>
          </div>
          <div
            v-if="isMaintainer"
            class="col-12 text-center d-flex justify-content-around pt-2"
          >
            <!-- <button
              class="button logo m-0 py-2"
              @click="$emit('openBookModal')"
            >
              Editar
            </button>
            <button
              class="button primary m-0 py-2"
              @click="showModal.deleteModal = true"
            >
              Eliminar
            </button> -->
            <button
              class="button primary m-0 py-2"
              @click="$emit('toggleCard')"
            >
              Ver detalles
            </button>
          </div>
          <div v-if="!isMaintainer" class="col-12 text-center">
            <div @click="showModal.ratingModal = true" style="z-index: 2;">
              <i
                class="fas fa-star text-secondary"
                v-for="(item, i) in new Array(bookData.rating)"
                :key="`checked-${i}`"
              />
              <i
                class="fas fa-star text-gray"
                v-for="(item, i) in new Array(5 - bookData.rating)"
                :key="`unchecked-${i}`"
              />
            </div>

            <div
              class="message-box"
              v-if="!isMaintainer"
              @click="showModal.commentsModal = true"
              style="z-index: 2;"
            >
              <unicon name="comment-alt-lines" :fill="grayCol" />
              <div class="counter">
                {{ bookData.commentsCount }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <RatingModal
      :bookData="bookData"
      v-if="showModal.ratingModal && !isMaintainer"
      @close="showModal.ratingModal = false"
      @setRating="setRating"
    />
    <CommentsModal
      :bookData="bookData"
      v-if="showModal.commentsModal && !isMaintainer"
      @close="showModal.commentsModal = false"
      @addedComment="addedComment"
      @deletedComment="deletedComment"
    />
    <!-- <DeleteModal
      v-if="showModal.deleteModal"
      title="Desea eliminar esta asignación?"
      @close="closeModal"
      @delete="deleteCourseBook"
    /> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import RatingModal from "@/components/Books/RatingModal";
import CommentsModal from "@/components/Books/CommentsModal";
// import DeleteModal from "@/components/Books/DeleteModal";

export default {
  name: "BookCard",
  props: ["data", "isMaintainer", "assignationData"],
  components: {
    RatingModal,
    CommentsModal,
    // DeleteModal,
  },
  data() {
    let { secCol, grayCol } = this.$store.getters;

    return {
      secCol,
      grayCol,
      bookData: null,
      showModal: {
        ratingModal: false,
        commentsModal: false,
        deleteModal: false,
      },
    };
  },
  computed: {
    ...mapState(["userData", "dataUrl", "teacherData"]),
  },
  watch: {
    data(newValue) {
      if (newValue) this.bookData = newValue;
    },
  },
  methods: {
    // closeModal() {
    //   this.showModal.deleteModal = false;
    //   this.selectedComment = null;
    // },
    // async deleteCourseBook() {
    //   const apiUrl = `${this.dataUrl}/courseBook/deleteCourseBook`;
    //   const params = new URLSearchParams(
    //     `courseId=${this.assignationData.course.id}&bookId=${this.assignationData.book.id}`
    //   );

    //   let loader = this.$loading.show();

    //   try {
    //     let { data } = await this.axios.delete(apiUrl, { params });

    //     if (data.status.name.toLocaleLowerCase() == "ok") {
    //       this.$emit("deleteBook", this.assignationData.id);
    //       this.showModal.deleteModal = false;
    //       this.$notify({
    //         title: ["Se ha borrado la asignación de libro"],
    //         type: "success",
    //       });
    //     } else {
    //       this.$notify({
    //         title: ["Ocurrio un error"],
    //         type: "danger",
    //       });
    //     }
    //   } catch {
    //     this.$notify({
    //       title: ["Ocurrio un error"],
    //       type: "danger",
    //     });
    //   } finally {
    //     loader.hide();
    //   }
    // },
    addedComment() {
      this.bookData.commentsCount++;
    },
    deletedComment() {
      this.bookData.commentsCount--;
    },
    setRating(rating) {
      this.bookData.rating = rating;
      this.showModal.ratingModal = false;
    },
    async setFavorite() {
      let apiUrl = `${this.dataUrl}/bookUserFavorite/addFavoriteBookToUser`;
      let method = "post";
      let params = [];
      if (this.bookData.userFavorite) {
        apiUrl = `${this.dataUrl}/bookUserFavorite/deleteFavoriteBookToUser?userId=${this.teacherData.id}&bookId=${this.bookData.id}`;
        method = "delete";
      }
      params.push(apiUrl);

      let apiData = {
        book: {
          id: this.bookData.id,
        },
        user: {
          id: this.teacherData.id,
        },
      };

      if (!this.bookData.userFavorite) params.push(apiData);

      let loader = this.$loading.show();

      try {
        let { data } = await this.axios[method](...params);

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.bookData.userFavorite = !this.bookData.userFavorite;
          this.$notify({
            title: ["Cambio exitoso"],
            type: "success",
          });
        } else {
          this.$notify({
            title: ["Ocurrio un error"],
            type: "danger",
          });
        }
      } catch {
        this.$notify({
          title: ["Ocurrio un error"],
          type: "danger",
        });
      } finally {
        loader.hide();
      }
    },
  },
  mounted() {
    this.bookData = this.data;
  },
};
</script>

<style lang="scss" scoped>
.like-container {
  padding: 6px 7px;
  background: white;
  margin-left: auto;
  margin-top: -18px;
  width: 45px;
  position: absolute;
  right: 0;
  z-index: 2;
}

.like {
  font-size: 30px;
}

.icon {
  font-size: 60px;
}

p {
  font-size: 12px;
}

.message-box {
  position: absolute;
  top: 0;
  right: 0;
  box-shadow: 0 0px 3px 3px rgba(64, 64, 64, 0.1);
  top: 0;
  right: -11px;
  padding: 0 9px;
  padding-top: 6px;
  border-radius: 3px;
}

.counter {
  position: absolute;
  top: -12px;
  right: -5px;
  background: var(--color-logo);
  width: 18px;
  height: 18px;
  color: white;
  border-radius: 50%;
  text-align: center;
  line-height: 18px;
}

.card-title {
  min-height: 50px;
}

.card-body {
  min-height: 180px;
}
</style>
